import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

const CooldownButton = ({ onClickHandler = () => {} }) => {
  const COOLDOWN_HOURS = 24;
  const COOLDOWN_MS = COOLDOWN_HOURS * 60 * 60 * 1000;

  const [isDisabled, setIsDisabled] = useState(false);
  const [remaining, setRemaining] = useState(null);

  useEffect(() => {
    const lastClick = localStorage.getItem("lastButtonClick");
    if (lastClick) {
      const timePassed = Date.now() - parseInt(lastClick, 10);
      if (timePassed < COOLDOWN_MS) {
        setIsDisabled(true);
        setRemaining(COOLDOWN_MS - timePassed);
      }
    }
  }, []);

  // Update remaining time every minute
  useEffect(() => {
    if (!isDisabled || remaining <= 0) return;

    const interval = setInterval(() => {
      setRemaining((prev) => {
        if (prev <= 60000) {
          clearInterval(interval);
          setIsDisabled(false);
          localStorage.removeItem("lastButtonClick");
          return 0;
        }
        return prev - 60000;
      });
    }, 60000);

    return () => clearInterval(interval);
  }, [isDisabled, remaining]);

  const formatTime = (ms) => {
    const hours = Math.floor(ms / (1000 * 60 * 60));
    const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));
    return `${hours}h ${minutes}m`;
  };

  const handleClick = () => {
    onClickHandler();
    localStorage.setItem("lastButtonClick", Date.now().toString());
    setIsDisabled(true);
    setRemaining(COOLDOWN_MS);
  };

  const renderTooltip = (props) => (
    <Tooltip id="cooldown-tooltip" {...props}>
      {isDisabled
        ? `This will enable in ${formatTime(remaining)}`
        : "Click to perform this action"}
    </Tooltip>
  );

  const isDisplayButton = (
    <>
      <Button
        className="styled-button-styles"
        variant="outline-primary"
        style={{
          marginTop: "10px",
          pointerEvents: isDisabled ? "none" : "auto",
          // display: "none",
        }}
        onClick={handleClick}
        disabled={isDisabled}
      >
        {"Generate Detailed Report"}
      </Button>
    </>
  );

  return isDisabled ? (
    <OverlayTrigger placement="top" overlay={renderTooltip}>
      <span className="d-inline-block"> {isDisplayButton}</span>
    </OverlayTrigger>
  ) : (
    <>{isDisplayButton}</>
  );
};

export default CooldownButton;
